module.exports = __webpack_public_path__ + "static/media/logo.13ea79c9.png";